/**
 * ベンダーライブラリの初期化
 *
 * このファイルはベンダーライブラリの読み込みと初期化を行います。
 * 基本的に編集する必要はありません。
 *
 * ベンダーの有効/無効は build.json で管理します。
 * 各ベンダーの設定は src/assets/vendors/xxx/init.js で行います。
 *
 * __VENDOR_XXX__ はビルド時に true/false に置換されます（gulpfile.js の esbuild define）
 * これによりTree Shakingが効き、false の場合はバンドルから完全に除外されます
 */

/**
 * ベンダー初期化
 */
export async function initVendors() {
  // Splide（スライダー）
  // eslint-disable-next-line no-undef
  if (__VENDOR_SPLIDE__ && document.querySelector("[data-splide]")) {
    const [{ default: Splide }, { initSplide }] = await Promise.all([
      import("@splidejs/splide"),
      import("@/assets/vendors/splide/init.js"),
    ]);

    // ※ Splide CSSはGulpのSCSSタスクで読み込み済み

    // 拡張機能を収集
    const extensions = {};

    // Auto Scroll拡張
    // eslint-disable-next-line no-undef
    if (__VENDOR_SPLIDE_AUTO_SCROLL__) {
      const { AutoScroll } = await import(
        "@splidejs/splide-extension-auto-scroll"
      );
      extensions.AutoScroll = AutoScroll;
      console.log("✅ Splide AutoScroll extension loaded");
    }

    initSplide(Splide, extensions);
    console.log("✅ Splide initialized");
  }

  // Micromodal（モーダル）
  // eslint-disable-next-line no-undef
  if (__VENDOR_MICROMODAL__ && document.querySelector("[data-micromodal-trigger], .modal")) {
    const [{ default: MicroModal }, { initMicromodal }] = await Promise.all([
      import("micromodal"),
      import("@/assets/vendors/micromodal/init.js"),
    ]);

    // ※ Micromodal CSSはGulpのSCSSタスクで読み込み済み

    initMicromodal(MicroModal);
    console.log("✅ Micromodal initialized");
  }

  // simpleParallax（パララックス）
  // eslint-disable-next-line no-undef
  if (__VENDOR_SIMPLE_PARALLAX__ && document.querySelector("[data-parallax], .js-parallax")) {
    const [{ default: SimpleParallax }, { initSimpleParallax }] = await Promise.all([
      import("simple-parallax-js/vanilla"),
      import("@/assets/vendors/simple-parallax/init.js"),
    ]);

    initSimpleParallax(SimpleParallax);
    console.log("✅ SimpleParallax initialized");
  }

  // GSAP（アニメーション）
  // eslint-disable-next-line no-undef
  if (__VENDOR_GSAP__ && document.querySelector("[data-gsap], .js-gsap")) {
    const [{ gsap }, { initGsap }] = await Promise.all([
      import("gsap"),
      import("@/assets/vendors/gsap/init.js"),
    ]);

    // ScrollTriggerプラグイン
    let ScrollTrigger = null;
    // eslint-disable-next-line no-undef
    if (__VENDOR_GSAP_SCROLL_TRIGGER__) {
      ({ ScrollTrigger } = await import("gsap/ScrollTrigger"));
      gsap.registerPlugin(ScrollTrigger);
      console.log("✅ GSAP ScrollTrigger plugin loaded");
    }

    initGsap(gsap, ScrollTrigger);
    console.log("✅ GSAP initialized");
  }

  // ========================================
  // 今後追加するベンダーはここに追加
  // ========================================
}
